module.exports = __webpack_public_path__ + "images/6e5af29d9d41c41021b17eebf3d8a61c-IMG_7038.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/kitchen/IMG_7038.jpg
// module id = ./src/assets/images/slides/kitchen/IMG_7038.jpg
// module chunks = 0